import {Injectable} from '@angular/core';
import {BaseConverter} from '../../base/converters/base-converter.converter';
import {DraftModel} from '../models/draft.model';
import {Draft} from '../../shared/DTO/draft';
import * as moment from 'moment';
import {DraftOperatorConverter} from "./draft-operator.converter";

@Injectable()
export class DraftConverter extends BaseConverter<DraftModel, Draft> {

  constructor(private draftOperatorConverter: DraftOperatorConverter) {
    super();
  }

  convertToDto(model: DraftModel): Draft {
    if (!model) {
      return;
    }
    return {
      articleTypes: model.articleTypes,
      creationDate: model.creationDate?.toISOString() || undefined,
      expirationDate: model.expirationDate?.toISOString() || undefined,
      management: model.management,
      modifyDate: model.modifyDate?.toISOString() || undefined,
      name: model.name,
      operator: this.draftOperatorConverter.convertToDto(model.operator),
      processId: model.processId,
      reserved: model.reserved,
      state: model.state,
      unit: model.unit
    };
  }

  convertToModel(dto: Draft): DraftModel {
    if (!dto) {
      return;
    }
    let model: DraftModel = new DraftModel();

    model.unit = dto.unit;
    model.state = dto.state;
    model.reserved = dto.reserved;
    model.processId = dto.processId;
    model.operator = this.draftOperatorConverter.convertToModel(dto.operator);
    model.name = dto.name;
    model.modifyDate = dto.modifyDate ? moment(dto.modifyDate) : null;
    model.management = dto.management;
    model.expirationDate = dto.expirationDate ? moment(dto.expirationDate) : null;
    model.creationDate = dto.creationDate ? moment(dto.creationDate) : null;
    model.articleTypes = dto.articleTypes;

    return model;
  }

}
